import { Hero } from '@/components/sections/Hero'
import { Challenge } from '@/components/sections/Challenge'
import { OurWork } from '@/components/sections/OurWork'
import { Ecosystem } from '@/components/sections/Ecosystem'
import { About } from '@/components/sections/About'
import { Partners } from '@/components/sections/Partners'
import { Media } from '@/components/sections/Media'
import { Donate } from '@/components/sections/Donate'
import { Contact } from '@/components/sections/Contact'
import { SummitLightbox } from '@/components/ui/SummitLightbox'
import { Seo } from '@/components/seo/Seo'

export function HomePage() {
  return (
    <>
      <Seo path="/" />
      <Hero />
      {/* Stats removed per Website Review — may return once figures are finalized. */}
      <Challenge />
      <OurWork />
      <Ecosystem />
      <Partners />
      <About />
      <Media />
      <Donate />
      <Contact />
      <SummitLightbox />
    </>
  )
}
